import React from "react";
import { t } from "../../../i18n";
import { GROUND_KEYS } from "../appeal";
import { OptionCard } from "../OptionCard";
import { AppealWizard } from "../useAppealWizard";

/** Passo 3: fundamentos técnicos e jurídicos que a IA vai usar. */
export const GroundsStep: React.FC<{ w: AppealWizard }> = ({ w }) => (
  <>
    <p className="text-body text-fg-muted">{t("appeals.grounds.intro")}</p>
    <div className="stagger flex flex-col gap-2.5">
      {GROUND_KEYS.map((key) => (
        <OptionCard
          key={key}
          selected={w.activeGrounds.includes(key)}
          onClick={() => w.toggleGround(key)}
          title={t(`appeals.grounds.${key}.title`)}
          description={t(`appeals.grounds.${key}.description`)}
        />
      ))}
    </div>
    <p className="text-caption text-fg-muted">{t("appeals.grounds.tip")}</p>
  </>
);
